import type { ReactNode } from "react";
import { cn } from "../lib/cn";

type InlineAlertProps = {
  tone: "success" | "danger" | "info" | "neutral";
  children: ReactNode;
  className?: string;
};

export function InlineAlert({ tone, children, className }: InlineAlertProps) {
  return (
    <div
      className={cn("cf-inline-alert", className)}
      data-tone={tone}
      role={tone === "danger" ? "alert" : "status"}
    >
      {children}
    </div>
  );
}
